import { broadcast, BROADCAST_TRIGGER } from './broadcast'

type Props = {
  redirect?: string
}

export const signOut = async ({ redirect }: Props = {}) => {
  const response = await fetch('/api/auth/sign-out', {
    method: 'POST',
    credentials: 'include',
  })

  if (!response.ok) {
    throw new Error('Failed to logout')
  }

  broadcast().postMessage({
    event: 'session',
    data: { trigger: BROADCAST_TRIGGER.SIGN_OUT },
  })

  if (redirect) {
    window.location.href = redirect
  } else {
    window.location.reload()
  }
}
